module.exports = __webpack_public_path__ + "img/icon_unselected_shizi.917ca6d7.png";